import { render } from "./OrdersNav.vue?vue&type=template&id=557a8a58&scoped=true"
import script from "./OrdersNav.vue?vue&type=script&lang=ts"
export * from "./OrdersNav.vue?vue&type=script&lang=ts"

import "./OrdersNav.vue?vue&type=style&index=0&id=557a8a58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-557a8a58"

export default script